import type { PartnerConfig } from './types'

export const cdmPartner: PartnerConfig = {
  slug: 'cdm',
  host: 'cdm.letsroave.com',
  displayName: 'CDM 2026',
  // CDM stands for Cali Da Mela. The promoter brands the event as "CDM 2026"
  // everywhere public, so the short form stays the headline and the expansion
  // is used once, for people who do not know what the initials mean.
  eventFullName: 'Cali Da Mela 2026',
  eventDateIso: '2026-10-17',
  eventDateLabel: 'Saturday, October 17, 2026',
  doorsOpen: '12:00',
  eventEnd: '23:00',
  agePolicy: 'All ages. Under 16 must be accompanied by an adult.',
  venue: {
    name: 'Cal Expo',
    addressLine: '1600 Exposition Blvd',
    city: 'Sacramento',
    region: 'CA',
    postalCode: '95815',
    lat: 38.5953,
    lng: -121.4342,
  },
  airportCode: 'SMF',
  airportName: 'Sacramento International Airport',
  airportDriveMinutes: 12,
  searchDefaults: {
    locationName: 'Sacramento (CA)',
    locationCode: 122739,
    locationType: 'city',
    locationLabel: 'United States',
    checkIn: '2026-10-16',
    checkOut: '2026-10-18',
    adults: 2,
    currency: 'USD',
    nationality: 'US',
  },
  officialSiteUrl: 'https://cdm2026.info/',
  ticketsHandle: '@calidamela',
  ticketDisclaimer:
    'Official updates and tickets exclusively available through @calidamela.',
  logoSrc: '/img/partners/cdm/cdm-logo-dark.png',
  logoSrcOnDark: '/img/partners/cdm/cdm-logo-white.png',
  logoAlt: 'CDM 2026',
  palette: {
    bg: '#FFFFFF',
    surface: '#F5F5F5',
    // Roave's own site ink (--color-dark-1), so partner copy reads as
    // native Roave content rather than a foreign template.
    ink: '#032843',
    // Roave's brand gold, not the promoter's red: the partner page's calls
    // to action should match the rest of Roave (this is the same value as
    // the site's "Find deals" button, src/styles/sass/main.scss:342).
    // Sparing use only (a CTA background, a small label) — it must never
    // become the page background. The promoter's own red is #D81C1C, kept
    // here only as a note in case the partnership ever wants it back.
    accent: '#9C7D5C',
    // AA math on the new white page (previously checked against #080808,
    // which no longer applies): #032843 ink is ~15.1:1 on white. The gold
    // accent is 3.82:1 against white, which clears AA for large text and
    // for a button fill carrying white text at button scale, but NOT for
    // small accent text — so small accent copy uses the deeper #7D6247
    // (5.66:1) instead, see --cdm-accent-text in cdm.module.scss. For
    // muted text: the
    // promoter's own #777777 is ~4.48:1 on white — just under the 4.5:1
    // floor — and the previous dark-surface muted #8A8A8A collapses to
    // ~3.45:1 on white, nowhere close. #595959 is the lightest grey that
    // still clears AA on both white (~7.0:1) and the #F5F5F5 card surface
    // used below (~6.4:1).
    muted: '#595959',
  },
}
